import type { ReactNode } from 'react'
import { PageBreadcrumb } from '@/components/ui/PageBreadcrumb'

export interface LegalSection {
  heading: string
  body: ReactNode
}

interface LegalDocumentProps {
  /** Page/document title, e.g. "Terms and Conditions". */
  title: string
  /** Short introductory line shown under the title. */
  subtitle?: string
  /** Human-readable date of the latest revision. */
  lastUpdated: string
  sections: LegalSection[]
}

/**
 * Shared layout for static legal pages (Terms and Conditions, Privacy Policy).
 * Mirrors the card styling used by other custom (non-template) pages so the
 * legal copy stays readable without altering the marketing template CSS.
 */
export function LegalDocument({ title, subtitle, lastUpdated, sections }: LegalDocumentProps) {
  return (
    <>
      <PageBreadcrumb title={title} hideContent compact />

      <section className="legal-section pt-60 md-pt-40 pb-100 md-pb-80">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-9 col-md-11">
              <div className="section-title text-center">
                <span className="sub-title">Legal</span>
                <h2>{title}</h2>
                {subtitle && <p style={{ color: '#6b7280' }}>{subtitle}</p>}
                <p style={{ color: '#9ca3af', fontSize: 14 }}>Last updated: {lastUpdated}</p>
              </div>

              <article
                className="legal-content"
                style={{
                  background: '#fff',
                  borderRadius: 20,
                  padding: 32,
                  boxShadow: '0 0 20px 0 rgba(0, 0, 0, 0.05)',
                }}
              >
                {sections.map((section) => (
                  <div key={section.heading} style={{ marginBottom: 28 }}>
                    <h3 style={{ fontSize: 20, marginBottom: 10, color: '#0c193d' }}>{section.heading}</h3>
                    <div style={{ color: '#4b5563', lineHeight: 1.7 }}>{section.body}</div>
                  </div>
                ))}
              </article>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
